import ViewFile from './ViewFile-redux';

export default ViewFile;
